export const isEmpty = (val: Record<string, unknown> | null | undefined) => val == null || !(Object.keys(val) || val).length;

export const isEqual = (a: any, b: any): boolean => {
    if (a === b) return true;
    if (a instanceof Date && b instanceof Date)
        return a.getTime() === b.getTime();
    if (!a || !b || (typeof a !== "object" && typeof b !== "object"))
        return a === b;
    if (a.prototype !== b.prototype) return false;
    let keys = Object.keys(a);
    if (keys.length !== Object.keys(b).length) return false;
    return keys.every((k) => isEqual(a[k], b[k]));
};